import { ROLES } from './enum';
import { getStorage, STORAGE_KEY } from './storage';
import { User } from '../types';

export const allowedRoles = [ROLES.ADMIN, ROLES.USER, ROLES.SUPER_ADMIN];

export const checkAuthentication = () => {
  return getStorage(STORAGE_KEY.TOKEN) && getStorage(STORAGE_KEY.USER);
};

export const checkAuthenticationAdmin = () => {
  const userRoles = getUserRolesStorage();
  const result =
    userRoles?.find((role: ROLES) => role === ROLES.ADMIN && allowedRoles.includes(role)) || false;
  return result;
};
export const checkAuthenticationSuperAdmin = () => {
  const userRoles = getUserRolesStorage();
  const result =
    userRoles?.find((role: ROLES) => role === ROLES.SUPER_ADMIN && allowedRoles.includes(role)) ||
    false;
  return result;
};

export const checkAuthenticationUser = () => {
  const userRoles = getUserRolesStorage();
  const result =
    userRoles?.find((role: ROLES) => role === ROLES.USER && allowedRoles.includes(role)) || false;
  return result;
};

export const getUserInfoStorage = (): User | null => {
  try {
    const userData = getStorage(STORAGE_KEY.USER);
    if (!userData) return null;
    return JSON.parse(userData);
  } catch (error) {
    console.error('Error parsing user data from localStorage:', error);
    return null;
  }
};

export const getUserRolesStorage = () => {
  const userInfo = getUserInfoStorage();

  // Check if userInfo and tokenParsed exist
  if (!userInfo || !userInfo.tokenParsed) {
    return [];
  }

  // Return roles from tokenParsed or empty array
  const roles = userInfo.tokenParsed.roles || [];
  return roles;
};

export const logout = () => {
  // Use Keycloak logout with redirect
  import('../utils/keycloak').then((keycloak) => {
    keycloak.default.doLogout({
      redirectUri: window.location.origin,
    });
  });
};

export const clearUserData = () => {
  // Clear all authentication-related data from localStorage
  localStorage.removeItem(STORAGE_KEY.TOKEN);
  localStorage.removeItem(STORAGE_KEY.USER);
  localStorage.removeItem(STORAGE_KEY.ID_TOKEN);
  localStorage.removeItem(STORAGE_KEY.ID);
  localStorage.removeItem(STORAGE_KEY.READ_BLOB_TOKEN);
  localStorage.removeItem('notification_subscription_id');

  // Clear cookie
  document.cookie = 'a_j=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export const getBearerToken = () => {
  return `Bearer ${getStorage(STORAGE_KEY.TOKEN)}`;
};

export const queryBuilder = (query: { [x: string]: string | null }) => {
  const search = new URLSearchParams();
  Object.keys(query).forEach((key) => {
    if (query[key]) {
      search.append(key, query[key] as string);
    }
  });

  return search.toString();
};

export const forceRefreshToken = async () => {
  try {
    const { authInstance } = await import('../utils/auth');
    await authInstance.syncAuth();
    // Trigger a custom event to notify components about token refresh
    window.dispatchEvent(new CustomEvent('tokenRefreshed'));
  } catch (error) {
    console.error('Failed to refresh token:', error);
  }
};
